import React from 'react';
import ServicePageTemplate from '../../../components/ServicePageTemplate/ServicePageTemplate';
import { getCategoryCatalog } from '../../../adapters/serviceCatalogAdapter';

const SpecialOccasionsPage = ({ onNavigate }) => {
  const catalog = getCategoryCatalog('specialOccasions');

  return (
    <ServicePageTemplate
      serviceType="specialOccasions"
      services={catalog.services}
      filters={catalog.filters}
      pageConfig={catalog.pageConfig}
      onNavigate={onNavigate}
    />
  );
};

export default SpecialOccasionsPage;

